var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoObjBiblio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 154,
    viewBox: "0 0 166 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2018_9764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2057 154C93.4564 154 120.411 127.061 120.411 93.8298C120.411 60.5985 93.4564 33.6592 60.2057 33.6592C26.955 33.6592 0 60.5985 0 93.8298C0 127.061 26.955 154 60.2057 154Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2056 137.685C84.4406 137.685 104.087 118.05 104.087 93.8295C104.087 69.6086 84.4406 49.9736 60.2056 49.9736C35.9706 49.9736 16.3242 69.6086 16.3242 93.8295C16.3242 118.05 35.9706 137.685 60.2056 137.685Z",
    fill: "#B4CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2056 118.833C74.0227 118.833 85.2236 107.639 85.2236 93.8297C85.2236 80.0206 74.0227 68.8262 60.2056 68.8262C46.3885 68.8262 35.1875 80.0206 35.1875 93.8297C35.1875 107.639 46.3885 118.833 60.2056 118.833Z",
    fill: "#F0F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74 38.9719L72.0827 93.7456L56.8854 94.7378L55.9429 99.7895L73.6692 98.633L136.33 43.8593L148.445 45.5219L166 30.2698L160.261 28.9893L146.859 40.6345L134.74 38.9719Z",
    fill: "#DDEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.485 24.8057L139.657 0.838031L139.523 0L122.035 15.1985L121.998 19.8513L121.938 27.2829L59.2532 82.0801L58.9279 83.8165L56.8853 94.7378L72.0826 93.7455L134.74 38.9718L146.858 40.6345L160.261 28.9892L141.485 24.8057Z",
    fill: "#B4CAE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2018_9764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoObjBiblio);
export default __webpack_public_path__ + "static/media/no_obj_biblio.aa520f20db7d8049882884ac9355c798.svg";
export { ForwardRef as ReactComponent };